import { useEffect, useState } from "react";
import { useShellHost } from "@/shell-handle/ShellHostProvider";
import type { MfeErrorState } from "@/shell-handle/mfeError";
import { ErrorPage } from "@/pages/ErrorPage/ErrorPage";
import { Styles } from "@/shared/coralreef";

export function MfeErrorOverlay() {
  const host = useShellHost();
  const [err, setErr] = useState<MfeErrorState | null>(
    host.mfeError.state.get(),
  );

  useEffect(() => host.mfeError.state.subscribe(setErr), [host]);

  if (!err) return null;
  return (
    <div
      data-testid="mfe-error-overlay"
      data-mfe-app={err.appName}
      data-mfe-message={err.message}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        background: Styles.Colours.darkestBlue,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflowY: "auto",
      }}
    >
      <ErrorPage />
    </div>
  );
}
